import type { TranslationMessages } from '../../types';

export const schedule: TranslationMessages = {
  title: 'Lịch làm việc',
  upcoming_shifts: 'Ca làm việc sắp tới',
  shift_details: 'Chi tiết ca làm việc',
  shift_time: 'Thời gian ca làm việc',
  shift_location: 'Địa điểm ca làm việc',
  shift_role: 'Vai trò ca làm việc',
  no_upcoming_shifts: 'Không có ca làm việc sắp tới',
  calendar_view: 'Chế độ xem lịch',
  month_view: 'Chế độ xem tháng',
  week_view: 'Chế độ xem tuần',
  day_view: 'Chế độ xem ngày',
  conflicts_title: 'Xung đột lịch trình',
  conflicts_count: 'Xung đột lịch trình (%{count})',
  conflict_overlap_description: 'Ca làm việc trùng với lịch trình hiện có',
  conflict_overlap_resolution: 'Điều chỉnh thời gian bắt đầu hoặc kết thúc',
  conflict_overtime_description:
    'Thành viên nhân viên sẽ vượt quá giới hạn giờ làm việc hàng tuần',
  conflict_overtime_resolution:
    'Giảm giờ làm việc hoặc giao cho nhân viên khác',
  conflict_unavailable_description:
    'Thành viên nhân viên không có mặt vào ngày này',
  conflict_unavailable_resolution:
    'Giao cho nhân viên khác hoặc thay đổi ngày',
  conflict_skill_mismatch_description:
    'Thành viên nhân viên thiếu kỹ năng cần thiết cho vị trí này',
  conflict_skill_mismatch_resolution:
    'Giao cho nhân viên có trình độ hoặc thay đổi vị trí',
  severity_critical: 'Nghiêm trọng',
  severity_high: 'Cao',
  severity_medium: 'Trung bình',
  severity_low: 'Thấp',
  shift_title_morning: 'Ca sáng',
  shift_title_evening: 'Ca tối',
  shift_title_weekend: 'Ca cuối tuần',
  location_main_store: 'Cửa hàng chính',
  role_barista: 'Nhân viên pha chế',
  role_cashier: 'Thu ngân',
  role_manager: 'Quản lý',
  controls_title: 'Điều khiển lịch',
  search_label: 'Tìm kiếm ca làm việc',
  search_placeholder: 'Tìm kiếm theo nhân viên, vị trí, địa điểm...',
  view_mode_label: 'Chế độ xem',
  position_label: 'Vị trí',
  position_all: 'Tất cả vị trí',
  calendar_title_prefix_monthly: 'Lịch trình hàng tháng',
  calendar_title_prefix_weekly: 'Lịch trình hàng tuần',
  calendar_title_prefix_daily: 'Lịch trình hàng ngày',
  calendar_title_prefix_yearly: 'Lịch trình hàng năm',
  calendar_description_month: 'Xem tất cả ca làm việc trong tháng',
  calendar_description_week: 'Xem ca làm việc trong tuần',
  calendar_description_day: 'Xem ca làm việc trong ngày đã chọn',
  calendar_description_year: 'Xem tất cả ca làm việc trong năm',
  year_view_title: 'Chế độ xem năm',
  year_view_subtitle: 'Tất cả ca làm việc cho năm %{year}',
  month_more_label: '+%{count} nữa',
  month_empty_label: 'Nhấp để thêm ca làm việc',
  day_empty_label: 'Không có ca làm việc nào được lên lịch',
  day_add_shift: 'Thêm ca làm việc',
  quick_stats_title: 'Thống kê nhanh',
  quick_stats_scheduled_label: 'Đã lên lịch',
  quick_stats_confirmed_label: 'Đã xác nhận',
  quick_stats_conflicts_label: 'Xung đột',
  quick_stats_staff_label: 'Nhân viên',
  nav_previous_year: 'Năm trước',
  nav_this_year: 'Năm nay',
  nav_next_year: 'Năm sau',
  nav_previous_week: 'Tuần trước',
  nav_this_week: 'Tuần này',
  nav_next_week: 'Tuần sau',
  nav_previous: 'Trước',
  nav_today: 'Hôm nay',
  nav_next: 'Tiếp',
  week_view_title: 'Chế độ xem tuần',
  week_view_subtitle: 'Tuần của %{date}',
  shifts_scheduled_count: '%{count} ca làm việc đã lên lịch',
  click_to_add_shift: 'Nhấp để thêm ca làm việc',
  to: 'đến',
  subtitle: 'Xem ca làm việc được giao và giờ làm việc của bạn',
  loading: 'Đang tải lịch trình...',
  stats_this_week: 'Tuần này',
  stats_shifts: 'Ca làm việc',
  stats_next_shift: 'Ca làm việc tiếp theo',
  stats_none: 'Không có',
  shift_singular: 'ca làm việc',
  shift_plural: 'ca làm việc',
  selected_day_notification: 'Đã chọn %{date}',
  no_shifts_for_day: 'Không có ca làm việc nào được lên lịch cho ngày này',
  this_week_shifts_title: 'Ca làm việc trong tuần này',
  this_week_shifts_description:
    'Các ca làm việc đã lên lịch của bạn cho tuần hiện tại',
  no_shifts_for_week: 'Không có ca làm việc nào được lên lịch cho tuần này',
  upcoming_shifts_description: 'Các ca làm việc sắp tới của bạn',
  today_label: 'Hôm nay',
  tomorrow_label: 'Ngày mai',
  status_scheduled: 'Đã lên lịch',
  status_confirmed: 'Đã xác nhận',
  status_completed: 'Đã hoàn thành',
  status_cancelled: 'Đã hủy',
  failed_to_load: 'Không thể tải dữ liệu lịch trình',
};
